export const identityTranslations = {
  en: {
    travelled: 'Travelled', mileZero: 'Mile zero', interactiveMap: 'Interactive trip map',
    recoveryEyebrow: 'A small detour', recoveryTitle: 'Something went off route.',
    recoveryBody: 'Your plans are safe. Reload the app to find the road again.',
    reload: 'Reload Tragenda',
  },
  tr: {
    travelled: 'Gidilen yollar', mileZero: 'Başlangıç noktası', interactiveMap: 'Etkileşimli gezi haritası',
    recoveryEyebrow: 'Küçük bir sapma', recoveryTitle: 'Yolda bir sorun çıktı.',
    recoveryBody: 'Planların güvende. Uygulamayı yeniden yükleyip devam edebilirsin.',
    reload: 'Tragenda’yı yeniden yükle',
  },
  sv: {
    travelled: 'Resta vägar', mileZero: 'Startpunkten', interactiveMap: 'Interaktiv resekarta',
    recoveryEyebrow: 'En liten omväg', recoveryTitle: 'Något kom ur kurs.',
    recoveryBody: 'Dina planer är säkra. Ladda om appen för att fortsätta resan.',
    reload: 'Ladda om Tragenda',
  },
} as const;
